import routePath from '@src/lib/routePath'

const publicCampaignPaths = {
  publicDetails: routePath(`/view-campaign/:campaignId/:channel?`),
  legacyPublicDetails: routePath(`/#/campaigns/:campaignId/activate`),
}

export default publicCampaignPaths
